const Footer = () => {
    return (
        <footer className={"footer"}>Website created and maintained by
            <br /><a href={"https://recursivequality.com/"}>Recursive Quality LLC</a></footer>
    )

}; export default Footer;